import React from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';
import api from '../../../../components/api';
import { yupErrorMsg } from '../../../../components/atoms/const';

function useAddPartnersDetails() {
  const { partnerId } = useParams();

  // navigate handler
  const navigation = useNavigate();
  const onNavigateBack = () => navigation(`/partners/${partnerId}`);
  const onNavigateLanding = () => navigation('/partners');

  // Get Partner By Id
  const { data: partnerRes, isLoading: partnerLoad } = useQuery(
    ['getById', 'partner', partnerId],
    () => api.partner.getById(partnerId!),
    {
      enabled: !!partnerId,
    },
  );
  const partnerById = React.useMemo(() => partnerRes?.data?.data, [partnerRes]);

  // Add New Partner
  const { mutate: addPartner, isLoading: addLoad } = useMutation(api.partner.add, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      console.log('success add', data);
      alert('success');
      onNavigateLanding();
    },
    onError: (error) => {
      console.log(error);
      alert('fail');
    },
  });

  const yupSchema = yup.object().shape({
    name: yup.string().required(yupErrorMsg.PARTNER_EMPTY),
    streetAddress: yup.string().required(yupErrorMsg.STREET_ADDRESS_EMPTY),
    zipCode: yup.number().required(yupErrorMsg.ZIP_CODE_EMPTY).test('len', yupErrorMsg.ZIP_CODE_INCORRECT_FORMAT, (val: any) => (val ? val.toString().length === 5 : false)),
    state: yup.string().required(yupErrorMsg.STATE_EMPTY),
    city: yup.string().required(yupErrorMsg.CITY_EMPTY),
    comission: yup.number().min(0, yupErrorMsg.COMMISION_POSITIVE).required(yupErrorMsg.COMMISION_EMPTY),
    firstname: yup.string().required(yupErrorMsg.FIRST_NAME_EMPTY),
    lastname: yup.string().required(yupErrorMsg.LAST_NAME_EMPTY),
    email: yup.string().email(yupErrorMsg.EMAIL_INCORRECT_FORMAT).required(yupErrorMsg.EMAIL_EMPTY),
    phoneNumber: yup.string().required(yupErrorMsg.PHONE_NUMBER_EMPTY),
    position: yup.string().required(yupErrorMsg.POSITION_EMPTY),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      streetAddress: '',
      zipCode: '',
      state: '',
      city: '',
      firstname: '',
      lastname: '',
      position: '',
      phoneNumber: '',
      email: '',
      comission: 0,
    },
    validationSchema: yupSchema,
    onSubmit: (values) => {
      addPartner({
        name: values.name,
        address: {
          streetAddress: values.streetAddress,
          zipCode: values.zipCode,
          state: values.state,
          city: values.city,
        },
        contactPerson: {
          firstname: values.firstname,
          lastname: values.lastname,
          position: values.position,
          phoneNumber: values.phoneNumber,
          email: values.email,
        },
        commision: values.comission,
      });
    },
  });

  return {
    partner: {
      data: partnerById,
      isLoading: partnerLoad,
    },
    partnerId,
    formik,
    onNavigateBack,
    onNavigateLanding,
    addLoad,
  };
}

export default useAddPartnersDetails;
